/**
 * MIT Sloan Management BigQuery
 */
(function ($) {
  class SMR_BigQuery {
    constructor() {
      this.prepopulate();
    }

    prepopulate() {
      if (location.hostname !== "sloanreview.mit.test") return;

      $('label.gfield_label:contains("First Name")').parent("li.gfield").find('input[type="text"]').val("Kevin");
      $('label.gfield_label:contains("Last Name")').parent("li.gfield").find('input[type="text"]').val("Leary");
      $('label.gfield_label:contains("Email")').parent("li.gfield").find('input[type="text"]').val("spam@kevinleary.net");
      $('label.gfield_label:contains("Country")').parent("li.gfield").find('select option[value="United States"]').prop("selected", true);
      $('label.gfield_label:contains("Country")').parent("li.gfield").find("select").trigger("chosen:updated");
      $('label.gfield_label:contains("Job Title")').parent("li.gfield").find('input[type="text"]').val("Web Developer");
      $('label.gfield_label:contains("Company")').parent("li.gfield").find('input[type="text"]').val("Kevinleary.net, LLC.");
      $('label.gfield_label:contains("Industry")').parent("li.gfield").find('select option[value="Ad Agencies"]').prop("selected", true);
      $('label.gfield_label:contains("Industry")').parent("li.gfield").find("select").trigger("chosen:updated");
    }
  }

  $(document).on("ready", (event) => {
    new SMR_BigQuery();
  });
})(window.jQuery);
